<template>
<div>
    <div class="relative mx-auto rounded-md" style="min-width:400px; max-width: 400px;"
    >
        <canvas
            id="canvas-bg"
            class="absolute top-0 bottom-0 right-0 left-0"
            style="z-index: 0"
        ></canvas>
        <canvas
            :ref="el => { canvasDynamic = el }"
            class="relative"
            style="z-index: 1"
            id="canvas"
        ></canvas>
        <div  v-if="spinner" style="z-index: 2" class="bg-spinner bg-white  bg-opacity-50 absolute inset-0 flex items-center justify-center">
            <svg class="animate-spin h-8 w-8 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
    </div>
</div>
</template>

<script>

import { computed, inject, onMounted } from '@vue/runtime-core';
import { nextTick, ref, watch } from 'vue'

// const MAX_SIZE = 35;

export default {
    props: ['refresh', 'getArea'],
    emits: ['updateData'],

    setup(props, { emit }) {

        const injectOpt = inject('option');

        // Variables
        const
            bgCanvas = ref(null),
            ctx = ref(null),
            canvasDynamic = ref(null),
            draw = ref(null),
            size = ref({
                width: null,
                height: null,
            }),
            spinner = ref(false),
            settings = ref({
                align: 'left',
                position: 'middle',
                fontSize: 30,

                positionSpace: 0,
            }),
            canvasOffset = ref(null),
            offsetX = ref(null),
            offsetY = ref(null),
            startX = ref(null),
            startY = ref(null),
            mouseX = ref(null),
            pos = ref(null),
            customFont = ref(false),
            ready = ref(false);

            const area = ref(null);

            if(injectOpt.value.variation) area.value = props.getArea();

            watch(() => injectOpt.value.variation, () => {
                if(injectOpt.value.variation) area.value = props.getArea();
            })

        onMounted(() => {
            bgCanvas.value = document.getElementById('canvas-bg').getContext('2d');
            ctx.value = canvasDynamic.value.getContext('2d');

            canvasOffset.value = $(canvasDynamic.value).offset();
            offsetX.value = canvasOffset.value.left;
            offsetY.value = canvasOffset.value.top;

            spinner.value = true;

            size.value.width = 400;
            size.value.height = 400;

            settings.value.fontSize = (area.value ? area.value.h : 35) / 1;

            nextTick(() => {
                ready.value = false;
                arrText(injectOpt.value.text, true);
                setSizeCanvas(size.value.width, size.value.height);
            })
        });


        // Functions
        const
            setSizeCanvas = (width, height) => {
                bgCanvas.value.canvas.width = width;
                bgCanvas.value.canvas.height = height;
                ctx.value.canvas.width = width;
                ctx.value.canvas.height = height;

                drawBackground();
            },
            drawBackground = (refresh = true, pictogram = null) => {

                if(pictogram || refresh) spinner.value = true;

                var img = new Image;

                pictogram = injectOpt.value.pictogram;

                if(injectOpt.value.variation) img.src = injectOpt.value.variation.engrave.image.url;

                if(injectOpt.value.variation){
                    img.onload = (ev) => {
                        let centerH = (size.value.height / 2) - (size.value.width / 2);

                        bgCanvas.value.clearRect(0, 0, size.value.width, size.value.width);
                        bgCanvas.value.drawImage(img, 0, centerH, size.value.width, size.value.width);

                        if(pictogram && pictogram != 'None') drawImage(pictogram);

                        if(refresh && injectOpt.value.variation){
                            drawText();
                        }else {
                            setTimeout(() => {
                                spinner.value = false;
                            }, 500)
                        }
                    }
                }
                else setTimeout(() => { spinner.value = false; }, 500)
            },
            drawImage = (val) => {
                var icon = new Image;
                icon.src = val.url;

                icon.onload = (ev) => {
                    let path = ev.path || (ev.composedPath && ev.composedPath());
                    let bottomH = size.value.height - path[0].height;

                    bgCanvas.value.drawImage(icon, 20, bottomH - 20, path[0].width, path[0].height);
                }
            },
            drawText = (refresh = true, custom) => {
                let mainArea = { x: area.value.x, y: area.value.y, w: area.value.w, h: area.value.h }
                draw.value = true;

                if(refresh) {

                    if(!customFont.value) {
                        settings.value.fontSize = Number( (mainArea.h / lines.value.length).toFixed(2) );
                        lines.value.forEach((item, key) => { item.fontSize = settings.value.fontSize; });
                    }
                }

                ctx.value.clearRect(0, 0, ctx.value.canvas.width, ctx.value.canvas.height);

                lines.value.forEach((element, key) => {

                    changeOption(null, element);

                    let textW = ctx.value.measureText(element.text).width;
                    let textC = textW / 2;
                    let center = ctx.value.canvas.width / 2;

                    changePosition(element, mainArea, textW, center, custom);

                    if(center - textC <= mainArea.x) element.scaled = true;
                    else element.scaled = false;

                    if(element.changePos && element.x + element.w > mainArea.w + mainArea.x) {
                        do element.x--;
                        while(element.x + element.w >= mainArea.w + mainArea.x && element.x > mainArea.x);

                        if(element.x <= mainArea.x) element.changePos = false;
                    }

                    if(element.scaled || element.reset) {
                        if(!element.scaleFont && textW >= mainArea.w){
                            do element.fontSize--;
                            while(element.x > mainArea.x);
                        }
                    }
                    else {
                        let count = 0;
                        lines.value.forEach((el, key) => {
                            count += el.fontSize;
                        })

                        if(count < mainArea.h && element.scaleFont && textW <= mainArea.w && !element.manualScaleFont){
                            do element.fontSize++;
                            while(count > mainArea.h);
                        }
                    }

                    if(lines.value.length > 1) {
                        let val = 0;
                        let full = 0;
                        lines.value.forEach((el, index) => {
                            if(key > 0 && index < key){
                                val += el.fontSize;
                            }
                            full += el.h;
                        });

                        element.textY = ( mainArea.y + val ) + element.fontSize / 2;
                        element.textY += (mainArea.h - full) / lines.value.length;

                        element.y = element.textY;
                    }
                    else element.textY = mainArea.y + (mainArea.h / 2);

                    if(element.x < mainArea.x) element.x = mainArea.x;
                    if(draw.value) {
                        ctx.value.fillText(
                            element.text,
                            element.x,
                            element.textY,
                            mainArea.w,
                        );
                    }
                });
                emit('updateData', lines.value);

                lines.value.forEach((el, key) => {
                    injectOpt.value.position[key] = Number(el.position);
                    injectOpt.value.fontSize[key] = Number(el.fontSize.toFixed(2));
                });

                setTimeout(() => {
                    spinner.value = false;
                    ready.value = true;
                }, 500)
            },
            changeOption = (value, el) => {
                if(!value){
                    ctx.value.fillStyle = injectOpt.value.color;
                    ctx.value.textBaseline = settings.value.position;
                    ctx.value.textAlign = settings.value.align;
                    if(!customFont.value) ctx.value.font = settings.value.fontSize + 'px ' + injectOpt.value.font.family;
                }
                else {
                    if(value == 'font') ctx.value[value] = settings.value[el] + 'px ' + injectOpt.value.font.family;
                    else ctx.value[value] = settings.value[el];
                }

                if(customFont.value) ctx.value.font = el.fontSize + 'px ' + injectOpt.value.font.family;

            },
            changePosition = (el, area, textW, center, custom) => {
                let c = (area.w / 2) - (textW / 2) + area.x;

                if(injectOpt.value.reset) {
                    el.changePos = false;
                    el.manualScaleFont = false;
                }

                el.w = textW;
                el.h = el.fontSize;
                el.x = el.changePos ? el.position : c;

                if(el.changePos) el.position = el.x;
                else el.position = c;

                if(pos.value != mouseX.value - startX.value){
                    pos.value = mouseX.value - startX.value;
                }
                if(custom){
                    let number = Number(el.position);

                    if(number >= area.x) el.x = el.position;
                    else el.x = area.x;

                    if(el.w + el.x >= area.w + area.x) {
                        el.x = area.w + area.x - el.w;
                    }
                }
            };

            const options = computed(() => { return Object.assign({}, injectOpt.value)})
            watch(
                options,
                (val, oldVal) => {
                    nextTick(() => {
                        if(injectOpt.value.variation) {
                            if( val.font.id != oldVal.font.id || val.color != oldVal.color ){
                                drawText();
                                spinner.value = true;
                            }

                            if( val.text != oldVal.text ) {
                                arrText(val.text, false);
                                drawText();
                            }
                            if(oldVal.variation == null || val.variation.engrave_id != oldVal.variation.engrave_id){
                                spinner.value = true;
                                drawBackground(false);
                            }
                            if(val.pictogram){
                                if(oldVal.pictogram == null || val.pictogram.id != oldVal.pictogram.id){
                                    drawBackground(false, val.pictogram);
                                }
                            }

                            if(!val.pictogram) drawBackground(false);
                            if(val.reset == true) {
                                customFont.value = null;
                                drawText();

                                injectOpt.value.reset = false;
                            }
                        }
                    });
                },
            );
            watch(injectOpt.value.position, (val, oldVal) => {
                val.forEach((el, index) => {
                    if(lines.value[index]) { lines.value[index].position = Number(el); }
                });
                if(ready.value) drawText(false, true);
            })
            watch(injectOpt.value.fontSize, (val, oldVal) => {
                const MAX = area.value.h;
                let count = 0;
                let toBig = false;

                val.forEach((item, key) => {
                    if(lines.value[key]){
                        count += lines.value[key].fontSize;
                        if(lines.value[key].x < area.value.x) lines.value[key].x = area.value.x;
                        // console.log(ctx.value.measureText(lines.value[key].text).width, area.value.w)
                        // if(ctx.value.measureText(lines.value[key].text).width > area.value.w) toBig = true;
                    }
                });
                if(count <= MAX && ready.value && toBig == false) {
                    drawText(true, false);
                    customFont.value = true;
                }

            })

            const lines = inject('lines');
            function arrText(text, refresh = false) {
                let arr = text.split('\n');
                let last = [];

                if(arr.length != lines.value.length) {
                    customFont.value = false;
                }

                lines.value.forEach((item, key) => {
                    last[key] = {
                        pos : item.changePos,
                        text : item.text,
                        maxH : item.maxH,
                        manualScaleFont: item.manualScaleFont,
                    };
                });

                lines.value = [];

                if(injectOpt.value.variation){
                    arr.forEach((el, key) => {
                    lines.value[key] = {
                        id: key + 1,
                        text: el,
                        textY: null,
                        x: null,
                        y: null,
                        w: null,
                        position: injectOpt.value.position[key] ? Number(injectOpt.value.position[key]) : area.value.w / 2,
                        changePos: last[key] ? last[key].pos : false,

                        fontSize: injectOpt.value.fontSize[key] ? Number(injectOpt.value.fontSize[key]) : null,
                        h: injectOpt.value.fontSize[key] ? Number(injectOpt.value.fontSize[key]) : 10,
                        maxH: last[key] ? last[key].maxH : injectOpt.value.fontSize[key],
                        scaleFont: last[key] ? last[key].scaleFont : false,
                        manualScaleFont: last[key] ? last[key].manualScaleFont : false,
                    };

                    if(el == '') lines.value[key].changePos = false;
                    if(last[key] && last[key].text != el) {

                        if(last[key].text.length > el.length) {
                            lines.value[key].scaleFont = true;
                        }
                        else lines.value[key].scaleFont = false;
                    }
                });
                }
            }

        return {
            // vars
            bgCanvas,
            ctx,
            size,
            settings,
            canvasDynamic,
            lines,
            area,
            spinner,

            // functions
            setSizeCanvas,
            drawBackground,
            drawText,

            canvasOffset,
            offsetX,
            offsetY,
            startX,
            startY,
        }
    },
}
</script>
